if (!customElements.get("copy-code-modal")) {
  class CopyCodeComponent extends HTMLElement {
    constructor() {
      super();
      const copy_btn = this.querySelector(".code_text_copy");
      const copy_text = this.querySelector(".sale_codes");
      let copy_btn_content = copy_btn?.innerHTML;
      copy_btn?.addEventListener('click', function() {
        const textToCopy = copy_text.textContent;
        navigator.clipboard.writeText(textToCopy).then(function() {
        copy_btn.innerHTML = `<span class="visually-hidden">Copied ${textToCopy} success.</span><svg aria-hidden="true" role="img"  aria-labelledby="copied1-icon-title" class="icon icon-check" viewBox="0 -65 434.67733 434"  xmlns="http://www.w3.org/2000/svg"><title id="copied1-icon-title">Copied</title><path d="m152.003906 304.34375c-5.460937 0-10.921875-2.089844-15.082031-6.25l-130.664063-130.667969c-8.34375-8.339843-8.34375-21.824219 0-30.164062 8.339844-8.339844 21.820313-8.339844 30.164063 0l115.582031 115.582031 246.253906-246.25c8.339844-8.339844 21.820313-8.339844 30.164063 0 8.339844 8.34375 8.339844 21.824219 0 30.167969l-261.332031 261.332031c-4.160156 4.160156-9.625 6.25-15.085938 6.25zm0 0"/></svg>`
          setTimeout(() => {
            copy_btn.innerHTML = copy_btn_content;
        }, 5000);
        }).catch(function(error) {
          console.error('Copy failed', error);
        });
      });
    }
  }
  customElements.define('copy-code-modal', CopyCodeComponent);
}